import { unifiedClient } from '@/lib/unified-fetch';
import { useMutation, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { TopUpFilter } from './topup';
import { readCache } from '@/store';

// Import response types are now defined in typings.d.ts using OpenAPI schemas

/**
 * Upload CSV file for coupon sales import
 */
export const useCouponImport = () => {
  return useMutation({
    mutationFn: async (file: File): Promise<API.ImportResponse> => {
      const formData = new FormData();
      formData.append('file', file);

      const response = await unifiedClient.app.POST('/coupon-sales/import', {
        body: formData as any,
        headers: {
          // Don't set Content-Type, let the browser set it for FormData
        },
      });

      return response.data as API.ImportResponse;
    },
  });
};

const useCouponSalesSummaryKey = ['coupon-sales', 'summary'];
export const useCouponSalesSummary = (startDate?: string, endDate?: string, options?: Partial<UseQueryOptions>) => {
  let opts = {
    queryKey: [useCouponSalesSummaryKey],
    queryFn: async () => {
      const response = await unifiedClient.app.GET('/coupon-sales/summary', {
        params: {
          query: {
            startDate: startDate || '',
            endDate: endDate || '',
          },
        },
      });

      if (response.data) {
        return response.data;
      }
      return [];
    }
  }
  Object.assign(opts, options);

  return useQuery(opts)
}

/**
 * Hook for coupon import with loading state and error handling
 */
export const useCouponImportWithState = () => {
  const mutation = useCouponImport();

  return {
    importCoupons: mutation.mutate,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
    isSuccess: mutation.isSuccess,
    data: mutation.data,
    reset: mutation.reset,
  };
};


//get currency rate
const useCurrencyRateKey = ['currency-rate'];

export const getCurrencyRate = async (startDate?: string, endDate?: string) => {
  return readCache<any, API.CurrencyRate[]>([useCurrencyRateKey, startDate, endDate]);
}

export const useCurrencyRate = (startDate?: string, endDate?: string, options?: Partial<UseQueryOptions>) => {
  let opts = {
    queryKey: [useCurrencyRateKey, startDate, endDate],
    queryFn: async () => {
      const response = await unifiedClient.admin.GET('/event_CurrencyRate/', {
        params: {
          query: {
            limit: 1000,
            offset: 0,
            filter: {
              date_gte: startDate || '',
              date_lte: endDate || '',
            }
          },
        },
      });

      if (response.data) {
        return response.data;
      }
      return [];
    }
  }
  Object.assign(opts, options);

  return useQuery(opts)
}